export enum ServiceType {
  PRIVET = 'PRIVET',
  PRIVET_PROMO = 'PRIVET_PROMO',
  PRIVET_PLUS = 'PRIVET_PLUS',
  PRIVET_CORP = 'PRIVET_CORP',
  UNDEFINED= 'UNDEFINED'
}
